import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
class Footer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    showAffiliatorLoginButton() {
        if (localStorage.getItem('info') === null || localStorage.getItem('info') === '') {
            return (
                <div className=""><Link to={'/login/affiliator'} className="footer_font">> {this.props.t('4')}</Link></div>
            )
        } else {
            return (
                <div className=""></div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //For Mobile view 
        if (isMobile) {
            return (
                <div className="footer_div mt-3" style={{ paddingTop: "20px" }}>
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-1" ></div>
                            <div className="col-md-3 service ">
                                <div className="row">
                                    <div className="col-md-1"></div>
                                    <div className="col-md-10">
                                        {/* <p className="footer_font">FIND SERVICES</p> */}
                                        <div className="">
                                            <Link to={'/Privacy-policy'} className="footer_font">> {this.props.t('2')}</Link>
                                        </div>
                                        <div className="mt-2">
                                            <Link to={'/terms-conditions'} className="footer_font">> {this.props.t('5')}</Link>
                                        </div>
                                        <div className="mt-2">
                                            <Link to={'/laws-regulations'} className="footer_font">> {this.props.t('0')}</Link>
                                        </div>
                                    </div>
                                    <div className="col-md-1"></div>
                                </div>
                            </div>

                            <div className="col-md-4 service ">
                                <div className="row">
                                    <div className="col-md-1"></div>
                                    <div className="col-md-10">
                                        {/* <p className="footer_font">SELL SERVICES</p>
                                        <p className="footer_font">> Sell</p>
                                        <p className="footer_font">> Tips for listing</p>
                                        <p className="footer_font">> Service price, paid options</p>
                                        <p className="footer_font">> Seller vinterview</p> */}
                                        <div className="mt-2">
                                            <Link to={'/transaction-flow'} className="footer_font">>{this.props.t('6')}</Link>
                                        </div>
                                        <div className="mt-2">
                                            {this.showAffiliatorLoginButton()}
                                        </div>
                                        {/* <div className="mt-2">
                                    <Link to={'/about'} className="footer_font">>{this.props.t('9')}</Link>
                                </div> */}
                                    </div>
                                    <div className="col-md-1"></div>
                                </div>
                            </div>

                            <div className="col-md-4 service ">
                                <div className="row">
                                    <div className="col-md-3"></div>
                                    <div className="col-md-5">
                                        {/* <p className="footer_font">LEARN MORE</p> */}

                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div className="footer_div mt-3" style={{ paddingTop: "20px" }}>
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-1" ></div>
                            <div className="col-md-3 service ">
                                <div className="row">
                                    <div className="col-md-1"></div>
                                    <div className="col-md-10">
                                        {/* <p className="footer_font">FIND SERVICES</p> */}
                                        <div className="">
                                            <Link to={'/Privacy-policy'} className="footer_font">> {this.props.t('2')}</Link>
                                        </div>
                                        <div className="mt-2">
                                            <Link to={'/terms-conditions'} className="footer_font">> {this.props.t('5')}</Link>
                                        </div>
                                        <div className="mt-2">
                                            <Link to={'/laws-regulations'} className="footer_font">> {this.props.t('0')}</Link>
                                        </div>
                                    </div>
                                    <div className="col-md-1"></div>
                                </div>
                            </div>

                            <div className="col-md-4 service ">
                                <div className="row">
                                    <div className="col-md-1"></div>
                                    <div className="col-md-10">
                                        {/* <p className="footer_font">SELL SERVICES</p>
                                    <p className="footer_font">> Sell</p>
                                    <p className="footer_font">> Tips for listing</p>
                                    <p className="footer_font">> Service price, paid options</p>
                                    <p className="footer_font">> Seller vinterview</p> */}
                                        <div className="">
                                            <Link to={'/transaction-flow'} className="footer_font">>{this.props.t('6')}</Link>
                                        </div>
                                        <div className="mt-2">
                                            {this.showAffiliatorLoginButton()}
                                        </div>
                                        {/* <div className="mt-2">
                                        <Link to={'/about'} className="footer_font">>{this.props.t('9')}</Link>
                                    </div> */}
                                    </div>
                                    <div className="col-md-1"></div>
                                </div>
                            </div>

                            <div className="col-md-4 service ">
                                <div className="row">
                                    <div className="col-md-3"></div>
                                    <div className="col-md-5">
                                        {/* <p className="footer_font">LEARN MORE</p> */}

                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export { Footer };

 Footer = withTranslation('src_Components_Common_Footer')(Footer);